



































import {Component, Prop, Vue} from "vue-property-decorator";
import format from "@/valchrom/views/dataset/NumberFormat";
import COLUMN_ORDER from "@/valchrom/views/dataset/ColumnOrder";
import {Getter} from "vuex-class";

@Component({})
export default class OverViewTable extends Vue {
    name = 'OverViewTable';
    @Prop() object : any;
    @Prop() included? : string[];
    @Getter overview_simplify !: boolean;

    format(val: any, data_type: string){
        return format(val, data_type);
    }

    genKeyStr(){
        var result = " :included=\"[";
        for (let column of this.object['columns']) {
            result += "'"+column.key+"',"
        }
        return result + "]\" ";
    }

    isDev(){
        let result = process.env.NODE_ENV === 'development' && !this.overview_simplify;
        return result
    }

    sortData(data:  any[]) {
        return data.concat().sort((data1:any,data2:any)=>{
            return (""+data1["level"]).localeCompare(""+data2["level"])
        })
    }

    dataMissing(column: string){
        for(let row of this.object['data']){
            if(row[column]){
                return false
            }
        }
        return true
    }

    sortColumns(columns:Object[]):Object[]{
        return columns.sort((col1:any, col2:any) => {
            return COLUMN_ORDER.indexOf(col1.key)-COLUMN_ORDER.indexOf(col2.key);
        });
    }

    activeColumns() {
        if(this.included == undefined) {
            let result = [];
            for(let column of this.object['columns']){
                result.push({
                    key: column.key,
                    title: column.short_name+' '+ column.key
                })
            }
            return this.sortColumns(result);
        }
        let result = [];
        for (let column of this.object['columns']) {
            for(let included_col_key of this.included){
                if (column.key == included_col_key && !this.dataMissing(column.key)) {
                    result.push({
                        key: column.key,
                        title: column.short_name
                    })
                }
            }
        }
        return this.sortColumns(result);
    }
}
